import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { TechnicianService } from '../../../../services/technician.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-technician-availability',
  templateUrl: './technician-availability.component.html',
  styleUrls: ['./technician-availability.component.scss'],
})
export class TechnicianAvailabilityComponent implements OnInit {
  @Input() user;
  @Input() technicianID;
  @Input() messageService: MessageService;
  public fromDate: Date = null;
  public toDate: Date = null;
  public defaultWorkHours: any = {};
  public configuredWorkHours: any = [];
  public defaultDate = new Date(1970, 1, 1, 0, 0, 0);
  public selectedDates = [];
  public dates = [];
  public selectedDate: any = null;
  public loadingCalendar = false;

  constructor(
    private technicianService: TechnicianService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.fromDate = moment().startOf('month').toDate();
    this.toDate = moment().endOf('month').toDate();
    this.getAvailabilitySettings();
  }

  getAvailabilitySettings() {
    this.loadingCalendar = true;
    this.technicianService
      .getTechnicianiAvailabilitySettings(
        this.technicianID,
        moment(this.fromDate).format('YYYY-MM-DD'),
        moment(this.toDate).format('YYYY-MM-DD'),
      )
      .subscribe(
        (result) => {
          console.log(result);
          this.defaultWorkHours = {
            ...result.defaultWorkHours,
            mondayStart: result.defaultWorkHours.mondayStart || '00:00',
            mondayEnd: result.defaultWorkHours.mondayEnd || '00:00',
            tuesdayStart: result.defaultWorkHours.tuesdayStart || '00:00',
            tuesdayEnd: result.defaultWorkHours.tuesdayEnd || '00:00',
            wednesdayStart: result.defaultWorkHours.wednesdayStart || '00:00',
            wednesdayEnd: result.defaultWorkHours.wednesdayEnd || '00:00',
            thursdayStart: result.defaultWorkHours.thursdayStart || '00:00',
            thursdayEnd: result.defaultWorkHours.thursdayEnd || '00:00',
            fridayStart: result.defaultWorkHours.fridayStart || '00:00',
            fridayEnd: result.defaultWorkHours.fridayEnd || '00:00',
            saturdayStart: result.defaultWorkHours.saturdayStart || '00:00',
            saturdayEnd: result.defaultWorkHours.saturdayEnd || '00:00',
            sundayStart: result.defaultWorkHours.sundayStart || '00:00',
            sundayEnd: result.defaultWorkHours.sundayEnd || '00:00',
          };
          var configuredWorkHours = result.configuredWorkHours;
          this.selectedDates = configuredWorkHours.map((x) => {
            return new Date(x.date);
          });

          for (
            var date = moment(this.fromDate);
            moment(date).unix() <= moment(this.toDate).unix();
            date = moment(date).add(1, 'days')
          ) {
            var found = configuredWorkHours
              .filter((x) => {
                return (
                  moment(x.date).format('YYYY-MM-DD') ===
                  date.format('YYYY-MM-DD')
                );
              })
              .pop();
            if (!found) {
              if (moment(date).weekday() === 0) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.sundayStart,
                  endTime: this.defaultWorkHours.sundayEnd,
                  onlineHours: this.defaultWorkHours.sundayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.sundayStart != '00:00' ||
                    this.defaultWorkHours.sundayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 1) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.mondayStart,
                  endTime: this.defaultWorkHours.mondayEnd,
                  onlineHours: this.defaultWorkHours.mondayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.mondayStart != '00:00' ||
                    this.defaultWorkHours.mondayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 2) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.tuesdayStart,
                  endTime: this.defaultWorkHours.tuesdayEnd,
                  onlineHours: this.defaultWorkHours.tuesdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.tuesdayStart != '00:00' ||
                    this.defaultWorkHours.tuesdayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 3) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.wednesdayStart,
                  endTime: this.defaultWorkHours.wednesdayEnd,
                  onlineHours: this.defaultWorkHours.wednesdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.wednesdayStart != '00:00' ||
                    this.defaultWorkHours.wednesdayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 4) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.thursdayStart,
                  endTime: this.defaultWorkHours.thursdayEnd,
                  onlineHours: this.defaultWorkHours.thursdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.thursdayStart != '00:00' ||
                    this.defaultWorkHours.thursdayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 5) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.fridayStart,
                  endTime: this.defaultWorkHours.fridayEnd,
                  onlineHours: this.defaultWorkHours.fridayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.fridayStart != '00:00' ||
                    this.defaultWorkHours.fridayEnd !== '00:00',
                });
              } else if (moment(date).weekday() === 6) {
                configuredWorkHours.push({
                  date: date.format('YYYY-MM-DD'),
                  startTime: this.defaultWorkHours.saturdayStart,
                  endTime: this.defaultWorkHours.saturdayEnd,
                  onlineHours: this.defaultWorkHours.saturdayOnline,
                  default: true,
                  isWorking:
                    this.defaultWorkHours.saturdayStart != '00:00' ||
                    this.defaultWorkHours.saturdayEnd !== '00:00',
                });
              }
            }
          }
          this.configuredWorkHours = configuredWorkHours;
          this.loadingCalendar = false;
        },
        (err) => {
          this.loadingCalendar = false;
        },
      );
  }

  defaultUpdated() {
    var defaultHours = {
      ...this.defaultWorkHours,
      mondayStart:
        this.defaultWorkHours.mondayStart.length === 5
          ? this.defaultWorkHours.mondayStart
          : moment(this.defaultWorkHours.mondayStart).format('HH:mm'),
      mondayEnd:
        this.defaultWorkHours.mondayEnd.length === 5
          ? this.defaultWorkHours.mondayEnd
          : moment(this.defaultWorkHours.mondayEnd).format('HH:mm'),
      tuesdayStart:
        this.defaultWorkHours.tuesdayStart.length === 5
          ? this.defaultWorkHours.tuesdayStart
          : moment(this.defaultWorkHours.tuesdayStart).format('HH:mm'),
      tuesdayEnd:
        this.defaultWorkHours.tuesdayEnd.length === 5
          ? this.defaultWorkHours.tuesdayEnd
          : moment(this.defaultWorkHours.tuesdayEnd).format('HH:mm'),
      wednesdayStart:
        this.defaultWorkHours.wednesdayStart.length === 5
          ? this.defaultWorkHours.wednesdayStart
          : moment(this.defaultWorkHours.wednesdayStart).format('HH:mm'),
      wednesdayEnd:
        this.defaultWorkHours.wednesdayEnd.length === 5
          ? this.defaultWorkHours.wednesdayEnd
          : moment(this.defaultWorkHours.wednesdayEnd).format('HH:mm'),
      thursdayStart:
        this.defaultWorkHours.thursdayStart.length === 5
          ? this.defaultWorkHours.thursdayStart
          : moment(this.defaultWorkHours.thursdayStart).format('HH:mm'),
      thursdayEnd:
        this.defaultWorkHours.thursdayEnd.length === 5
          ? this.defaultWorkHours.thursdayEnd
          : moment(this.defaultWorkHours.thursdayEnd).format('HH:mm'),
      fridayStart:
        this.defaultWorkHours.fridayStart.length === 5
          ? this.defaultWorkHours.fridayStart
          : moment(this.defaultWorkHours.fridayStart).format('HH:mm'),
      fridayEnd:
        this.defaultWorkHours.fridayEnd.length === 5
          ? this.defaultWorkHours.fridayEnd
          : moment(this.defaultWorkHours.fridayEnd).format('HH:mm'),
      saturdayStart:
        this.defaultWorkHours.saturdayStart.length === 5
          ? this.defaultWorkHours.saturdayStart
          : moment(this.defaultWorkHours.saturdayStart).format('HH:mm'),
      saturdayEnd:
        this.defaultWorkHours.saturdayEnd.length === 5
          ? this.defaultWorkHours.saturdayEnd
          : moment(this.defaultWorkHours.saturdayEnd).format('HH:mm'),
      sundayStart:
        this.defaultWorkHours.sundayStart.length === 5
          ? this.defaultWorkHours.sundayStart
          : moment(this.defaultWorkHours.sundayStart).format('HH:mm'),
      sundayEnd:
        this.defaultWorkHours.sundayEnd.length === 5
          ? this.defaultWorkHours.sundayEnd
          : moment(this.defaultWorkHours.sundayEnd).format('HH:mm'),
    };
    this.resetEndTimes(defaultHours);

    this.technicianService
      .updateTechnicianDefaultHours(this.technicianID, defaultHours)
      .subscribe((res) => {
        this.getAvailabilitySettings();
        this.messageService.add({
          detail: this.translate.instant(
            'bikeshop.users.default_working_hours_updated',
          ),
        });
      });
  }

  resetEndTimes(defaultHours) {
    if (defaultHours.mondayStart > defaultHours.mondayEnd) {
      defaultHours.mondayEnd = defaultHours.mondayStart;
    }
    if (defaultHours.tuesdayStart > defaultHours.tuesdayEnd) {
      defaultHours.tuesdayEnd = defaultHours.tuesdayStart;
    }
    if (defaultHours.wednesdayStart > defaultHours.wednesdayEnd) {
      defaultHours.wednesdayEnd = defaultHours.wednesdayStart;
    }
    if (defaultHours.thursdayStart > defaultHours.thursdayEnd) {
      defaultHours.thursdayEnd = defaultHours.thursdayStart;
    }
    if (defaultHours.fridayStart > defaultHours.fridayEnd) {
      defaultHours.fridayEnd = defaultHours.fridayStart;
    }
    if (defaultHours.saturdayStart > defaultHours.saturdayEnd) {
      defaultHours.saturdayEnd = defaultHours.saturdayStart;
    }
    if (defaultHours.sundayStart > defaultHours.sundayEnd) {
      defaultHours.sundayEnd = defaultHours.sundayStart;
    }

    if (
      Math.round(
        moment('1970-01-01T' + defaultHours.mondayEnd).diff(
          '1970-01-01T' + defaultHours.mondayStart,
          'minutes',
        ) / 60,
      ) < defaultHours.mondayOnline
    ) {
      defaultHours.mondayOnline =
        Math.floor(
          moment('1970-01-01T' + defaultHours.mondayEnd).diff(
            '1970-01-01T' + defaultHours.mondayStart,
            'minutes',
          ) / 60,
        ) || 0;
    }
    if (
      Math.round(
        moment('1970-01-01T' + defaultHours.tuesdayEnd).diff(
          '1970-01-01T' + defaultHours.tuesdayStart,
          'minutes',
        ) / 60,
      ) < defaultHours.tuesdayOnline
    ) {
      defaultHours.tuesdayOnline =
        Math.floor(
          moment('1970-01-01T' + defaultHours.tuesdayEnd).diff(
            '1970-01-01T' + defaultHours.tuesdayStart,
            'minutes',
          ) / 60,
        ) || 0;
    }
    if (
      Math.round(
        moment('1970-01-01T' + defaultHours.wednesdayEnd).diff(
          '1970-01-01T' + defaultHours.wednesdayStart,
          'minutes',
        ) / 60,
      ) < defaultHours.wednesdayOnline
    ) {
      defaultHours.wednesdayOnline =
        Math.floor(
          moment('1970-01-01T' + defaultHours.wednesdayEnd).diff(
            '1970-01-01T' + defaultHours.wednesdayStart,
            'minutes',
          ) / 60,
        ) || 0;
    }
    if (
      Math.round(
        moment('1970-01-01T' + defaultHours.thursdayEnd).diff(
          '1970-01-01T' + defaultHours.thursdayStart,
          'minutes',
        ) / 60,
      ) < defaultHours.thursdayOnline
    ) {
      defaultHours.thursdayOnline =
        Math.floor(
          moment('1970-01-01T' + defaultHours.thursdayEnd).diff(
            '1970-01-01T' + defaultHours.thursdayStart,
            'minutes',
          ) / 60,
        ) || 0;
    }
    if (
      Math.round(
        moment('1970-01-01T' + defaultHours.fridayEnd).diff(
          '1970-01-01T' + defaultHours.fridayStart,
          'minutes',
        ) / 60,
      ) < defaultHours.fridayOnline
    ) {
      defaultHours.fridayOnline =
        Math.floor(
          moment('1970-01-01T' + defaultHours.fridayEnd).diff(
            '1970-01-01T' + defaultHours.fridayStart,
            'minutes',
          ) / 60,
        ) || 0;
    }
    if (
      Math.round(
        moment('1970-01-01T' + defaultHours.saturdayEnd).diff(
          '1970-01-01T' + defaultHours.saturdayStart,
          'minutes',
        ) / 60,
      ) < defaultHours.saturdayOnline
    ) {
      defaultHours.saturdayOnline =
        Math.floor(
          moment('1970-01-01T' + defaultHours.saturdayEnd).diff(
            '1970-01-01T' + defaultHours.saturdayStart,
            'minutes',
          ) / 60,
        ) || 0;
    }
    if (
      Math.round(
        moment('1970-01-01T' + defaultHours.sundayEnd).diff(
          '1970-01-01T' + defaultHours.sundayStart,
          'minutes',
        ) / 60,
      ) < defaultHours.sundayOnline
    ) {
      defaultHours.sundayOnline =
        Math.floor(
          moment('1970-01-01T' + defaultHours.sundayEnd).diff(
            '1970-01-01T' + defaultHours.sundayStart,
            'minutes',
          ) / 60,
        ) || 0;
    }
  }

  formatTime(value) {
    return value === null || value === undefined
      ? '00:00'
      : moment((value.length === 5 ? '1970-01-01T' : '') + value).format(
          'HH:mm',
        );
  }

  getMaxHours(start, end) {
    if (
      start === null ||
      start === undefined ||
      end === null ||
      end === undefined ||
      (start === '00:00' && end === '00:00')
    )
      return 0;
    if (start.toString().length > 5) {
      start = moment(start).format('HH:mm');
    }
    if (end.toString().length > 5) {
      end = moment(end).format('HH:mm');
    }
    return moment('1970-01-01T' + end).diff(
      moment('1970-01-01T' + start),
      'hours',
    );
  }

  updateDateSelected(selectedDate) {
    if (selectedDate) {
      var data = {
        id: selectedDate.id,
        date: moment(selectedDate.date).toDate(),
        startTime: moment('1970-01-01T' + selectedDate.startTime).toDate(),
        endTime: moment('1970-01-01T' + selectedDate.endTime).toDate(),
        onlineHours: selectedDate.onlineHours,
        isWorking: selectedDate.working,
      };

      this.updateTechnicianActualHours({
        ...data,
        date: moment(data.date).format('YYYY-MM-DD'),
        startTime: moment(data.startTime).format('HH:mm:ss'),
        endTime: moment(data.endTime).format('HH:mm:ss'),
      });

      if (!selectedDate.working) {
        this.selectedDate = null;
      } else {
        this.selectedDate = data;
      }
    }
  }

  updateTechnicianActualHours(data, reload = false) {
    this.configuredWorkHours = this.configuredWorkHours.map((x) => {
      if (
        moment(x.date).format('YYYY-MM-DD') ===
        moment(data.date).format('YYYY-MM-DD')
      ) {
        return data;
      }
      return x;
    });

    this.technicianService
      .updateTechnicianActualHours(this.technicianID, data)
      .subscribe((res) => {
        this.configuredWorkHours = this.configuredWorkHours.map((x) => {
          if (
            moment(x.date).format('YYYY-MM-DD') ===
            moment(data.date).format('YYYY-MM-DD')
          ) {
            return res;
          }
          return x;
        });

        if (reload) {
          this.getAvailabilitySettings();
          this.messageService.add({
            detail: this.translate.instant(
              'bikeshop.users.working_hours_updated',
            ),
          });
        }
      });
  }

  actualUpdated() {
    if (this.selectedDate.endTime <= this.selectedDate.startTime) {
      this.selectedDate.endTime = this.selectedDate.startTime;
    }
    console.log(this.selectedDate);
    if (
      Math.floor(
        moment(this.selectedDate.endTime).diff(
          this.selectedDate.startTime,
          'minutes',
        ) / 60,
      ) < this.selectedDate.onlineHours
    ) {
      this.selectedDate.onlineHours =
        Math.floor(
          moment(this.selectedDate.endTime).diff(
            this.selectedDate.startTime,
            'minutes',
          ) / 60,
        ) || 0;
    }
    this.updateTechnicianActualHours(
      {
        ...this.selectedDate,
        date: moment(this.selectedDate.date).format('YYYY-MM-DD'),
        startTime: moment(this.selectedDate.startTime).format('HH:mm:ss'),
        endTime: moment(this.selectedDate.endTime).format('HH:mm:ss'),
      },
      true,
    );
  }

  getMonthData(event) {
    this.fromDate = event.fromDate;
    this.toDate = event.toDate;
    this.getAvailabilitySettings();
  }

  resetHours(day) {
    if (day === 'MONDAY') {
      this.defaultWorkHours.mondayStart = '00:00';
      this.defaultWorkHours.mondayEnd = '00:00';
    } else if (day === 'TUESDAY') {
      this.defaultWorkHours.tuesdayStart = '00:00';
      this.defaultWorkHours.tuesdayEnd = '00:00';
    } else if (day === 'WEDNESDAY') {
      this.defaultWorkHours.wednesdayStart = '00:00';
      this.defaultWorkHours.wednesdayEnd = '00:00';
    } else if (day === 'THURSDAY') {
      this.defaultWorkHours.thursdayStart = '00:00';
      this.defaultWorkHours.thursdayEnd = '00:00';
    } else if (day === 'FRIDAY') {
      this.defaultWorkHours.fridayStart = '00:00';
      this.defaultWorkHours.fridayEnd = '00:00';
    } else if (day === 'SATURDAY') {
      this.defaultWorkHours.saturdayStart = '00:00';
      this.defaultWorkHours.saturdayEnd = '00:00';
    } else if (day === 'SUNDAY') {
      this.defaultWorkHours.sundayStart = '00:00';
      this.defaultWorkHours.sundayEnd = '00:00';
    }
    this.defaultUpdated();
  }
}
